module.exports = __webpack_public_path__ + "img/games-text.63ba5205.svg";